import { ThemeProvider, createTheme } from "@mui/material";
import { useEffect, useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { useSelector } from "react-redux";
import MainPage from '../Views/Pages/Main';

import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "../Views/Pages/Dashborad";
const getActiveTheme = (themeMode) => {
  console.log('themeMode: ', themeMode)
  return createTheme({
    pageColor: themeMode === 'true' || !themeMode ? '#efefef': '#000',

    bgPrimary: themeMode === 'true' || !themeMode ? '#efefef': '#070707',
    bgSecondary: themeMode === 'true' || !themeMode ? 'green': 'red',
    bgGradient: themeMode === 'true' || !themeMode ? 'linear-gradient(to top , #FC9D00,transparent);'  : 'linear-gradient(to top , #FC9D00 ,#1f1e2900);',

    textPrimary: themeMode === 'true' || !themeMode ? '#000000': '#fff',
    textSecondary: themeMode === 'true' || !themeMode ? 'white': '#FC9C00',

    switchColor: themeMode === 'true' || !themeMode ? '#6c6c6c': '#b1b1b1',
  })
}
const ThemeContainer = () => {
  const currentTheme = useSelector((state) => state.LDTheme.value);
  const [activeTheme, setActiveTheme] = useState(getActiveTheme(currentTheme));

  useEffect(()=>{    
    setActiveTheme(getActiveTheme(currentTheme))
  },[currentTheme]);
  return (
    <ThemeProvider theme={activeTheme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
        <Route exact path="/" element={<MainPage />} />
          <Route exact path="/dashboard" element={<Dashboard />} />
          </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default ThemeContainer;